import React from 'react';
import Loading from 'components/Loading/Loading';
import { Flex, Box } from '@chakra-ui/react';

function LoadingDuplicatingModalContent() {
  return (
    <>
      <Flex justifyContent="center" padding="1rem 0 2rem">
        <Loading size="lg" />
      </Flex>
      <Box paddingBottom="1rem">Please wait ...</Box>
    </>
  );
}

export default LoadingDuplicatingModalContent;
